<template lang="pug">
  .box_expanded_scope
    .table-scope(@click="setExpanded")
      vm-table(:data="category" width="100%")
        template(slot="thead")
          vm-th
        template(slot-scope="{data}")
          vm-tr
            vm-td
              vm-icon(:icon="expandedFlag ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'")
              span.title_box_scope {{ category.type }}
    div(:class="{ hidden : !expandedFlag }")
      .table
        vm-table(:data="details")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'fabricated_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column != 'status' && column != 'fabricated_date' && column != 'total' && column != 'unit_price' && column != 'add_fabricated'") {{data[indextr][column]}}
</template>

<script>
export default {
  name: 'ExpandedScope',
  components: {
  },
  data: () => ({
    expandedFlag: false,
    columns: [
      'scope',
      'fabricated',
      'fabricated_date',
      'shipped'
    ]
  }),
  props: {
    category: {
      type: Object
    },
    reset: {
      type: Boolean
    }
  },
  computed: {
    details () {
      return this.category.details
    }
  },
  methods: {
    openViewer (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    deleteRow (data) {
      this.$emit('delete', data)
    },
    editRow (data) {
      this.$emit('edit', { detail: data, category: this.category })
    },
    setFabricated (data) {
      this.$emit('set-fabricated', data)
    },
    doReset () {
      this.reset = false
    },
    setExpanded () {
      this.expandedFlag = !this.expandedFlag
    },
    setFabricatedHistory (data) {
      this.$emit('history', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.hidden {
  visibility: hidden;
  display: none;
  opacity: 0;
  transition: all .25s ease;
}
.title_box_scope {
  margin-left: 15px;
  font-size: 18px;
}
.box_expanded_scope {
  cursor: pointer;
}
</style>
